"use client"
import React from 'react';

export default function ErrorFallback({
  reset,
}: {
  reset: () => void;
}) {
  return (
    <div className="error-fallback">
      <h2>Something went wrong:</h2>
      <div>
        <button onClick={reset}>Try again</button>
      </div>
    </div>
  );
}